// 浩克事件
export const HOWXM = {
    // 企业管理-管理员
    VISIT_ADMINISTRATOR: 'visit_administrator',
    // 企业管理-外部组织
    VISIT_CROSSCROP: 'visit_crosscrop'
};
